export default {
	default:{
		submit:"提交",
		SendVerificationCode:"发送验证码",
		VerificationCode:"验证码",
		VerificationCodeTip:"请输入验证码",
		MessageAuthenticationCode:"短信验证码",
		EmailAuthenticationCode:'邮箱验证码',
		VerificationCodeError:'验证码输入错误',
		PasswordsNotMatch:"两次密码输入不一致",
		PasswordChangeSuccess:"密码修改成功",
		PasswordError:"密码错误",
		CNY:'元',
		USD:'美元',
		TRY:'土耳其里拉',
		Notice:"提示",
		Done:'确定',
		ErrorSendingEmail:'邮箱验证码发送失败，请检查您的邮件地址是否错误',
		SuccessSendingEmail:'邮箱验证码发送成功，请检查您的邮件',
		ErrorSendingMessage:'短信验证码发送失败，请检查您的手机号码是否输入错误',
		SuccessSendingMessage:'短信验证码发送成功，请注意查收',
		Resend:'重新发送',
		EmailCodeErr:'邮箱验证码错误',
		ImgCodeErr:'图片验证码错误',
		MessageCodeErr:'短信验证码错误'
	},
	nav:{
		UserCenter:'用户中心',
		MyAccount:'我的账号',
		SecurityCenter:'安全中心',
		ChangePassword:'密码修改',
		RealNameAuthentication:'实名认证',
		Phone:'手机绑定和修改',
		Email:'邮箱绑定和修改',
		SecurityQuestion:'密保问题',
		VoucherCenter:'充值中心',
		GameRecharge:'游戏充值',
		RechargeHistory:'充值记录',
		AccountComplaint:'账号异常申诉',
		ThirdAccount:'第三方账号'
	},
	header:{
		Login:"登录",
		Logout:"注销",
		GameLists:"游戏列表",
		UserCenter:"用户中心",
		SecurityCenter:"安全中心",
		VoucherCenter:"充值中心",
		CustomerServiceCenter:"客服中心",
		Language:"切换语言",
		CurrentPosition:"当前位置",
	},
	games:{
		battleTeams1:"生死狙击1",
		battleTeams2:"生死狙击2", 
		battleTeamsMobile:"生死狙击手游",
	},
	home:{
		AccountInformation:"账号信息",
		UserName:"用户名",
		Nickname:"昵称",
		TheLatestLoginDate:"上次登录时间",
		SecurityLevel:"安全级别",
		SecurityTip:"为了账号安全，建议您开启以下设置",
		Change:"修改",
		Bind:"绑定",
		Setting:"设置",
		Submitted:"已提交",
		Bound:"已绑定",
		Set:"已设置",
		Unsubmitted:"未提交",
		Unbound:"未绑定",
		Notset:"未设置",
		PasswordLevel:"密码等级",
		Security:"安全性",
		SecurityLow:'一般',
		SecurityHigh:'高',
		PasswordLevelLow:"您的密码安全性一般，建议修改",
		PasswordLevelHigh:"您的密码安全性较高",
		PersonalInformation:"实名信息",
		RealNameTip:"主要用于账号防沉迷认证，是账号申诉的重要凭证",
		MobilePhonebinding:"绑定手机",
		SecurityQuestionTip:"有助于修改密码等相关重要功能操作",
		Emailbinding:"绑定邮箱",
		SecurityQuestion:"密保问题",
		NicknameTip:'请输入昵称',
		NicknameSet:'昵称设置成功'
	},
	password:{
		ChangePassword:"密码修改",
		CurrentPassword:"原密码",
		CurrentPasswordTip:"请输入原密码",
		NewPassword:"新密码",
		NewPasswordTip:"请输入新密码",
		ConfirmPassword:"确认密码",
		ConfirmPasswordTip:"请再次输入密码",
		ForgotPassword:"忘记密码？找回密码",
		PasswordsNotMatch:"两次密码输入不一致",
		PasswordChangeSuccess:"密码修改成功",
		OldPasswordError:"旧密码输入错误",
		NewPasswordSameAsOldPassword:"新密码和旧密码不能相同",
		SetPassword:'设置密码'
	},
	forgot:{
		RecoverPassword:"密码找回",
		RecoverPasswordTip:"可通过以下三种方式找回密码，若存在其他问题请进入客服中心寻求人工服务",
		SecurityMobilePhone:"密保手机",
		SecurityEmail:"密保邮箱",
		SecurityQuestion:"密保问题",
		UserName:"用户名",
		SecurityQuestion:"密保问题",
		SecurityAnswer:"密保答案",
		SecurityAnswerTip:"请输入密保答案",
		SecurityAnswerError:"密保答案错误",
		NewPassword:"新密码",
		NewPasswordTip:"请输入新密码",
		ConfirmPassword:"确认密码",
		NewPasswordAgainTip:"请再次输入密码",
		PhoneTip:"请输入手机号",
		VerificationCode:"验证码",
		VerificationCodeTip:"请输入验证码",
		SendVerificationCode:"发送验证码",
		EmialTip:"请输入邮箱",
		Confirmation:"确认",
		PasswordsNotMatch:"两次密码输入不一致",
		PasswordChangeSuccess:"密码修改成功",
		NotBoundPhone:'您还未绑定手机号码',
		NotBoundEmail:'您还未绑定邮箱',
		NotSetQuestion:'您还未设置密保问题',
	},
	realName:{
		Name:"姓名",
		NameTip:"请输入真实姓名",
		IDCard:"身份证",
		IDCardTip:"请输入身份证号码",
		SetRealnameSuccess:"实名认证成功",
		ModifyTip:'修改实名认证信息，请前往客服中心联系客服',
		ReCertification:'重新认证',
		SetRealnameFail:'认证失败，请输入相匹配的个人信息',
		MisMatch:'认证信息不匹配，请重新输入'
	},
	phone:{
		MobilePhonebinding:"手机绑定",
		MobilePhoneNumber:"手机号",
		MobilePhoneNumberTip:"请输入手机号",
		VerificationCode:"验证码",
		VerificationCodeTip:"请输入验证码",
		SuccessTip:"绑定手机设置状态：",
		BoundtoMobilephone:"已绑定手机",
		ChangetheMobilephone:"修改手机",
		UnbindtheMobilephone:"解除手机绑定",
		Phonelossorabnormity:"手机丢失或异常?",
		MessageAuthenticationCode:"短信验证码",
		NewBindPhone:'新绑定手机',
		BindingNewPhone:'绑定新手机',
		Next:'下一步',
		CheckOldPhone:'验证原手机',
		HadBindOther:'该手机已绑定其他账号',
		PleaseCheckOldPhone:'请先验证原手机号'
	},
	email:{
		Email:'邮箱',
		EmailTip:"请输入邮箱",
		Emailbinding:"邮箱绑定",
		SuccessTip:"绑定邮箱设置状态：",
		BoundtoEmail:"已绑定邮箱",
		ChangetheEmail:"修改邮箱",
		UnbindtheEmail:"解除邮箱绑定",
		Emaillossorabnormity:"邮箱丢失或异常?",
		UnbindingEmailSuccessfully:"解除邮箱绑定成功",
		EmailFormat:'邮箱格式错误'
	},
	question:{
		SecurityQuestion:"密保问题",
		SecurityAnswer:"问题答案",
		SecurityAnswerTip:"请输入问题答案",
		ConfirmAnswer:"确认答案",
		ConfirmAnswerTip:"请再次输入问题答案",
		SetQuestionSuccess:"密保问题设置成功",
		QuestionNotMatch:"两次密保答案不一致",
		AnswerLength:'密保答案长度不能超过20字',
	},
	complaint:{
		ComplaintCon:'当您无法从手机验证或邮箱验证途径修改信息时，您可以提供有效信息，如实名认证时使用的身份证（注意这是必须提交的），2-3笔账号充值记录等有效信息发送至官方邮箱kf@wooduan.com，官方将会在3-7个工作日为您处理，并返回处理信息至您的申诉邮箱。'
	},
	charge:{
		OnlineBank:"网上银行",
		RechargeAccount:"充值账号",
		ChoseGame:"选择游戏",
		ChoseServer:"选择区服",
		ServerSlt:"请选择您的游戏和服务器！",
		RechargeAmount:"充值数额",
		AmountTip:"输入其他数额",
		BanksTip:"选择银行",
		MoreBanks:"选择更多银行",
		Overview:"总览",
		Game:"游戏",
		Server:"区服",
		Price:"支付金额",
		Confirmthepayment:"确认支付",
		SuccessTip:"恭喜您，充值成功",
		OrderInformation:"订单信息",
		RechargeAccount:"充值账号",
		TopupGame:"充值游戏",
		Rechargeserver:"充值区服",
		Paymentmethod:"充值渠道",
		TotalrechargeAmount:"充值总额",
		Topupagain:"再次充值",
		RechargeHistory:"充值记录",
		GoldAmount:"{gold}金币",
		MoneyAmount:"{money}元",
		PayWithWeixin:'使用微信扫描二维码支付',
		TopupSuccessfully:"充值成功",
		TopupProblems:"充值遇到问题",
		ChoseAmount:"请选择充值数量",
		ChoseGameAndRegion:"请选择游戏和区服",
		ChoseChargeType:"请选择充值方式",
		TopupFailTip:'充值失败，请重新提交',
		TopupFailNeedService:"充值失败，请联系客服 {msg}",

		OrderNumber:'订单号',
		RedeemCode:'兑换码',
		Topup:'充值商品',
		ConfirmThePayment:'确认充值',
		TenAmount:'自定义金额充值(请输入10的倍数)',
		Unknown:'未知',
		Unpaid:'未付款',
		Recharging:'充值中',
		RechargeSuccessful:'充值成功',
		RechargeFailed:'充值失败',
		CancelTheRecharge:'取消充值',
		Refunded:'已退款',
		CancelTheRefund:'取消退款',
		RefundFailed:'退款失败',
		Refunding:'退款中',
		NewOrder:'新订单',
		StyleDeal:'待处理',
		Dealing:'处理中',
		Expired:'已过期',
		Checking:'审查中',
		Provider:'支付商'
	},
	chargeHistory:{
		LastWeek:"最近一周",
		LastMonth:"最近一月",
		HistoricalRecharge:"历史充值",
		QueryRange:"查询范围",
		Selectgames:"选择游戏",
		Pleaseselectagame:"请选择游戏",
		Inquire:"查询",
		Time:"时间",
		Account:"账号",
		GameServer:"游戏区服",
		Paymentmethod:"充值渠道",
		PaymentAmount:"支付金额",
		Status:"状态",
		Totalamount:"充值金额总计",
		Totalitems:"共{items}条",
	},
	login:{
		Login:"无端通行证登录",
		AccountLabel:"用户名/手机号/邮箱",
		PasswordLabel:"密码",
		ConfirmPassword:'确认密码',
		ConfirmPasswordLabel:'确认密码',
		LoginBtn:"立即登录",
		RegisterBtn:'立即注册',
		RegisterLink:"没有账号？立即注册",
		LoginLink:'已有账号？立即登录',
		ForgotLink:"忘记密码",
		QuickLogin:"快捷登录",
		Register:'无端通行证注册',
		RecoverByPhone:"密保手机找回密码",
		RecoverByQuestion:"密保问题找回密码",
		RecoverByEmail:"密保邮箱找回密码",
		Phone:"手机号码",
		UserName:"用户名",
		ResetPassword:"重置密码",
		RecoverByOther:"其他方式找回密码",
		SecurityEmail:"密保邮箱",
		SecurityQuestion:'密保问题',
		SecurityAnswer:'密保答案',
		PhoneAccountTip:'请输入你的账号或手机号码',
		PasswordTip:'请输入你的密码',
		PhoneNotReged:'手机号未注册',
		AccountNotReged:'账号未注册',
		LoginFail:'登录失败，请重新登录',
		RegSuccess:'注册成功，请登录',
		PhonwHasReged:'手机号已注册',
		AccountHasReged:'账号已被使用',
		RegFail:'注册失败，请重新注册',
		EmailHasReged:'邮箱已注册',
		PasswordErr:'密码至少包含一个数字或字母,6-16位',
		AccountErr:'用户名须以英文字母开头,不含中文,4-18位',
		RegAccountTip:'请输入用户名',
	},
	third:{
		RemoveBound:'解绑',
		UnbindSuccess:'解绑成功',
		ThirdAccountTip:'您可以绑定或解绑以下第三方账号，绑定后可使 用第三方账号快速登录',
		ThirdAccount:'第三方账号'
	},
	bind:{
		head:'账号绑定',
		tip:'请使用用户名/手机/邮箱绑定账号',
		bind:'立即绑定',
		or:'或者',
		auto:'自动生成账号',
		user:'用户名',
		password:'密码',
		noAccount:'还没账号，立即注册',
		hasAccount:'已有账号，立即绑定',
		regHead:'注册账号',
		regTip:'请填写注册信息',
		confirm_password:'确认密码',
		email:'邮箱',
		phone:'手机号',
		emailCode:'邮箱验证码',
		phoneCode:'手机验证码',
		getCode:'获取验证码',
		retry:'后重试',
		submit:'立即注册', 
		accountTip:'请输入账号',
		passwordTip:'请输入密码',
		passwordErr:'密码格式错误，密码6-16位 至少包含一个数字或字母,不包含特殊字符',
		confirmTip:'两次密码不一致',
		phoneTip:'请输入手机号',
		emailTip:'请输入邮箱',
		phoneErr:'手机号格式错误',
		emailErr:'邮箱格式错误',
		codeTip:'请输入验证码',
		bindErr:'绑定失败，请稍后再试',
		confirm:'确定',
		cancel:'取消',
		return:'返回',
		PhonwHasReged:'手机号已注册',
		AccountHasReged:'账号已注册',
		VerificationCodeError:'验证码错误',
		EmailHasReged:'邮箱已注册',
		ErrorSendingEmail:'邮箱验证码发送失败，请检查您的邮件地址是否错误',
		ErrorSendingMessage:'短信验证码发送失败，请检查您的手机号码是否输入错误',
		ParamErr:'参数错误'
	}
}


